/// <reference path="../wpt.ts" />
/*
    User group administration page - standalone, does not inherit widgets.
*/
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        class DetailLayoutUserAdmin extends Navigation.DetailLayoutBaseClass {
            constructor(typeName, core, handler, custom, context, readyCallback = null, secondaryActivationCallback = null) {
                super(typeName, core, handler, custom, context, readyCallback, secondaryActivationCallback);
            }
        }
        Navigation.DetailLayoutUserAdmin = DetailLayoutUserAdmin;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
